export default "__VITE_ASSET__BCYOSlwM__"